interface PreferredDocument {
  resource_id?: string;
  doc_id?: string;
  id?: string;
  file_type?: string;
  type?: string;
}

const normalizeType = (value: string) => value.toLowerCase().replace(/\s+/g, '_');
const stripType = (value: string) =>
  value.replace(/^(?:patent|publication|application|foreign_patent|foreign-patent|upload)-/i, '');

export function selectTaskDocument<Document extends { resource_id: string; file_type?: string }>(
  documents: Document[],
  preferred?: PreferredDocument | null
): Document | undefined {
  if (!preferred) return documents.length === 1 ? documents[0] : undefined;
  const identifier = preferred.resource_id || preferred.doc_id || preferred.id;
  if (!identifier || typeof identifier !== 'string') return undefined;
  const exact = documents.filter(document => document.resource_id === identifier);
  if (exact.length === 1) return exact[0];
  const type = preferred.file_type || preferred.type;
  const matches = documents.filter(
    document =>
      stripType(document.resource_id) === stripType(identifier) &&
      (!type || normalizeType(document.file_type || '') === normalizeType(type))
  );
  return matches.length === 1 ? matches[0] : undefined;
}
